import { Button } from '@progress/kendo-react-buttons';
import React from 'react'; 
 

const StatusYellowBarBtn = (props) => {
   const {label, btn1Disabled,btn2Disabled, btnName1, btnName2} = props;
    
    return (   
        <div className='row around-xs inputPair yellow-bottom-bar'>
            <div className='col-xs-12 col-sm-2 col-md-2 col-lg-2'></div>
            <div className="col-xs-10 col-sm-8 col-md-8 col-lg-8">
                <div className='yellowBarLabelLeft'>
                    {label}
                </div>
                
                <div className='yellowBarBtnRight'>
                    <Button className='k-button k-default btn-yellow-bg bt-upload' disabled={btn1Disabled} onClick={props.onClickSave}>{btnName1}</Button>
                    &nbsp;&nbsp;&nbsp;
                    <Button className="btn-success bt-upload" disabled={btn2Disabled} onClick={props.onClickDone}>{btnName2}</Button>      
                </div> 
            </div>
            <div className='col-xs-12 col-sm-2 col-md-2 col-lg-2'></div>
        </div> 
    )

}
export default StatusYellowBarBtn;